export class DataPolicyPageComponent implements ng.IComponentOptions {
  public controller:any = DataPolicyPageController;
  public template: string =
  `
    <div class="container container-fluid padding-2">
			<div class="row">
				<div class="col-md-12">
					<h1>Data Policy</h1>
				</div>
			</div>
			<div class="row margin-bottom-40px">
				<div class="col-md-12">
					<p>The data contained in DFMS can be used freely by any user of the portal as long as the usage does not violate the terms and conditions specified in the data policy.</p>
				</div>
			</div>
		</div>
  `;
}

export class DataPolicyPageController {
  public static $inject: Array<string> = ['$anchorScroll'];
  constructor (private $anchorScroll: ng.IAnchorScrollService) {

  }

  public $onInit() {
    this.$anchorScroll();
  }
}
